'use strict';

import angular from 'angular';
import 'angular-sanitize';
import 'ui-select';
import '../sections/sectionsServices';
import './menuServices';

const menuControllers = angular.module('applicationModule.menuControllers', [
    'ngSanitize',
    'applicationModule.menuServices',
    'applicationModule.sectionsServices',
    'ui.select'
]);

menuControllers.controller('MenuListController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'growl', 'Menu', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $modal, growl, Menu, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = true;
    $scope.application_id = $stateParams.application_id;


    if (angular.isDefinedNotEmpty($scope.application_id)) {

        $scope.isLoading = true;
        //
        Menu.getList($scope.application_id)
            .then(function (response) {
                if (angular.isDefined(response)) {
                    $scope.menu = response.menu;
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    } else {
        growl.error('MODULES.ERROR.NO_RESOURCE');
    }

    $scope.routeToElement = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.newMenu = function () {
        $scope.menu_new = {application_id: $scope.application_id};
        var modalInstance = $modal.open({
            templateUrl: 'views/application/menu/components/modal/menu.tpl.html',
            controller: 'MenuModalController',
            resolve: {
                menu: function () {
                    return angular.extend($scope.menu_new, {superadmin: Permissions.hasSuperAdminAccess()});
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.MENU.SUCCESS.MENU_CREATED');
        }).catch(() => {});
    };

    $scope.editMenu = function ($event, menu) {
        $event.stopImmediatePropagation();
        $scope.menu_new = {application_id: $scope.application_id};
        var modalInstance = $modal.open({
            templateUrl: 'views/application/menu/components/modal/menuEdit.tpl.html',
            controller: 'MenuModalEditController',
            resolve: {
                menu: function () {
                    return angular.extend(menu, {superadmin: Permissions.hasSuperAdminAccess()});
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.MENU.SUCCESS.MENU_CREATED');
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.deleteMenu = function ($event, menu) {
        $scope.isLoading = true;
        Menu.remove(menu.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.MENU.SUCCESS.MENU_DELETED');
                    $state.go('appsoup.application.menu', {application_id: $scope.application_id}, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.MENU.ERROR.MENU_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.changeOrder = function ($event, key1, key2) {
        $event.stopImmediatePropagation();
        Menu.changeOrder({order_ids: [$scope.menu[key1].id, $scope.menu[key2].id]})
            .then(function (response) {
                if (response.data.success) {
                    var tmp_order = $scope.menu[key1].order;
                    $scope.menu[key1].order = $scope.menu[key2].order;
                    $scope.menu[key2].order = tmp_order;

                    var tmp = angular.copy($scope.menu[key1]);
                    $scope.menu[key1] = angular.copy($scope.menu[key2]);
                    $scope.menu[key2] = tmp;
                }
            });
    };
    $scope.routeToElement = function ($event, menu_id) {
        $state.go('appsoup.application.menuEdit', {menu_id: menu_id}, {reload: true});
    };
}]);

menuControllers.controller('MenuModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Menu', 'Section', 'Client', 'menu', function ($scope, $state, $stateParams, $modalInstance, growl, Menu, Section, Client, menu) {
    $scope.menu = {};
    $scope.menus = [];
    Section.getSectionsList(menu.application_id).then(function (result) {
        let data = result.data;

        $scope.menus = data.pages.data;
    });
    $scope.showAdvanced = menu.superadmin;
    if (menu.name) {
        $scope.editMode = true;
        $scope.menu = angular.copy(menu);
    }
    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        var appId = menu.application_id;
        $scope.menu.application_id = appId;
        $scope.isLoading = true;
        Menu.save($scope.menu, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $modalInstance.close(data.menu);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.MENU.ERROR.MENU_CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };
    $scope.deleteSection = function () {
        $scope.isLoading = true;
        Section.remove($scope.section.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.SUCCESS.PAGE_DELETED');
                    $modalInstance.close(data.page);
                    $state.go('appsoup.application.sections', {application_id: $stateParams.application_id}, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.APP_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };
    $scope.inputErrors = {
        'sectionName': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.ERROR.REQUIRE.APP_NAME'}]
    };
}]);
menuControllers.controller('MenuModalEditController', ['$scope', '$state', '$stateParams', '$modalInstance', '$rootScope', 'growl', 'Menu', 'Section', 'Client', 'menu', function ($scope, $state, $stateParams, $modalInstance, $rootScope, growl, Menu, Section, Client, menu) {
    $scope.menu = {};
    $scope.menus = [];

    if (menu.name) {
        $scope.editMode = true;
        $scope.menu = angular.copy(menu);
    }
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = true;
    $scope.application_id = $stateParams.application_id;
    $scope.menu_id = $stateParams.menu_id;
    if (angular.isDefinedNotEmpty($scope.menu.id)) {
        $rootScope.doingResolve = true;
        Section.getSectionsList($scope.application_id).then(function (result) {
            let data = result.data;

            $scope.menus = data.pages.data;
        });
        Menu.get($scope.menu.id)
            .then(function (response) {
                var data = response.data;
                if (data.success) {
                    $scope.menu = data.menu;
                } else {
                    growl.error('MODULES.MENU.ERROR.DATA.' + data.error);
                    $state.go('appsoup.application.menu', {application_id: $scope.application_id});
                }
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    } else {
        growl.error('MODULES.ERROR.NO_RESOURCE');
    }
    $scope.cancel = function () {
        $state.go('appsoup.application.menu', {application_id: $scope.application_id}, {reload: true});
    };
    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        if ($scope.menu.name) {
            $scope.editMode = true;
        }
        Menu.save($scope.menu, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $state.go('appsoup.application.menu', {application_id: $scope.application_id}, {reload: true});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.MENU.ERROR.MENU_CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };
    $scope.deleteMenu = function () {
        $scope.isLoading = true;
        Menu.remove($scope.menu.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.MENU.SUCCESS.MENU_DELETED');
                    $state.go('appsoup.application.menu', {application_id: $scope.application_id}, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.MENU.ERROR.MENU_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };
}]);

menuControllers.controller('MenuPageController', ['$scope', '$rootScope', '$state', '$stateParams', '$modal', 'growl', 'Menu', 'Section', function ($scope, $rootScope, $state, $stateParams, $modal, growl, Menu, Section) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = true;
    $scope.application_id = $stateParams.application_id;
    $scope.menu_id = $stateParams.menu_id;
    if (angular.isDefinedNotEmpty($scope.menu_id)) {
        $rootScope.doingResolve = true;
        Section.getSectionsList($scope.application_id).then(function (result) {
            let data = result.data;

            $scope.menus = data.pages.data;
        });
        Menu.get($scope.menu_id)
            .then(function (response) {
                var data = response.data;
                if (data.success) {
                    $scope.menu = data.menu;
                } else {
                    growl.error('MODULES.MENU.ERROR.DATA.' + data.error);
                    $state.go('appsoup.application.menu', {application_id: $scope.application_id});
                }
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    } else {
        growl.error('MODULES.ERROR.NO_RESOURCE');
    }
    $scope.cancel = function () {
        $state.go('appsoup.application.menu', {application_id: $scope.application_id}, {reload: true});
    };
    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        if ($scope.menu.name) {
            $scope.editMode = true;
        }
        Menu.save($scope.menu, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $state.go('appsoup.application.menu', {application_id: $scope.application_id}, {reload: true});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.MENU.ERROR.MENU_CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };
    $scope.deleteMenu = function () {
        $scope.isLoading = true;
        Menu.remove($scope.menu.id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.MENU.SUCCESS.MENU_DELETED');
                    $state.go('appsoup.application.menu', {application_id: $scope.application_id}, {reload: true});
                } else if (data.error) {
                    growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.MENU.ERROR.MENU_DELETED');
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };
}]);

export default menuControllers;
